<template>
  <div class="page">
    <div class="select-tab flex-items">
      <a-select v-model="termId" style="width: 322px" @change="handleChange">
        <template>
          <a-select-option :value="item.id" v-for="item in termList" :key="item.id">{{
            item.termName
          }}</a-select-option>
        </template>
      </a-select>
      <div class="top-desc">{{ timeUpdateText }}</div>
    </div>

    <div class="plate-card top">
      <div class="plate-card-title mb24 flex-items">
        参与率
        <a-popover arrow-point-at-center placement="bottomLeft">
          <template slot="title">
            <p class="popover-title-b"><b>参与率</b></p>
          </template>
          <template slot="content">
            <ul class="popover-li">
              <li>
                <p><b>在册学员总数</b></p>
                <p>指所有学校状态为未删除、未归档的学员总数。</p>
                <p>备注：如果学校是“非认证”注册模式，本数据仅供参考。</p>
              </li>
              <li>
                <p><b>参与学员数</b></p>
                <p>
                  指在本学期，所有班级中的报名学员总数（去重），包含插班与转班。
                </p>
              </li>
              <li>
                <p><b>参与率</b></p>
                <p>参与率 = 参与学员数 / 在册学员数。</p>
              </li>
              <li>
                <p>
                  <b>普惠托管参与学员数</b>
                </p>
                <p>指在本学期，托管班级+社团班级报名学生去除重复的人数。</p>
              </li>
              <li>
                <p>
                  <b>兴趣课程参与学员数</b>
                </p>
                <p>指在本学期，社团班级+特色班级报名学生去除重复的人数。</p>
              </li>
              <li>
                <p><b>托管 / 社团 / 特色参与学员数</b></p>
                <p>
                  指在本学期，各类型班级中的报名学员总数（去重），包含插班与转班。
                </p>
              </li>
            </ul>
          </template>
          <a-icon class="icon-circle" type="question-circle" />
        </a-popover>
      </div>
      <div>
        <div class="flex-items mt24">
          <div class="flex-items flex1" style="flex: 1;">
            <div class="bd pd20 card1-bd flex flex1 mr16" style="width: 100%; height: 112px">
              <div class="card1-bd-icon mr20">
                <img src="/index/icon1.png" />
              </div>
              <div class="text-content">
                <h3 class="fsize30 flex-items">
                  <b>{{
                    currency(schoolTermOverPagePanelCoverage.regStudentCount, 0)
                  }}</b>
                </h3>
                <p class="fsize14">在册学员数</p>
              </div>
            </div>
          </div>
          <div class="flex-items flex1" style="flex: 1;">
            <div class="bd pd20 card1-bd flex flex1 mr16" style="width: 100%">
              <div class="card1-bd-icon mr20">
                <img src="/index/icon4.png" />
              </div>
              <div class="text-content">
                <h3 class="fsize30 flex-items">
                  <b>{{
                    currency(schoolTermOverPagePanelCoverage.parStudentCount, 0)
                  }}</b>
                  <div class="bd-l"></div>
                  <div class="percentage flex-items">
                    <b class="fsize20">
                      {{
                        calculatePercentage(
                          schoolTermOverPagePanelCoverage.parStudentCount,
                          schoolTermOverPagePanelCoverage.regStudentCount
                        )
                      }}
                    </b>
                    <span class="fsize14">参与率</span>
                  </div>
                </h3>
                <p class="fsize14">参与学员数</p>
              </div>
            </div>
          </div>
          <div class="flex-items" style="flex: 3;">
            <div class="flex-items flex1">
              <div class="bd flex1 mr16 merge" style="height: 112px">
                <div class="flex-items top-flex aic">
                  <div class="flex1 pdtm10">
                    <div class="icon mb9">
                      <img src="/index/icon11.png" style="width: 32px; height: 32px" />
                    </div>
                    <div class="text-line">
                      <div class="count fzize20">
                        <b>{{ currency(schoolTermOverPagePanelCoverage.generalOfferCount, 0)
                        }}
                        </b>
                      </div>
                      <p class="fsize14">普惠托管参与学员数</p>
                    </div>
                  </div>
                  <div class="bd-l2"></div>
                  <div class="flex1 pdtm10">
                    <div class="icon mb9">
                      <img src="/index/icon12.png" style="width: 32px; height: 32px" />
                    </div>
                    <div class="text-line">
                      <div class="count fzize20">
                        <b>{{ currency(schoolTermOverPagePanelCoverage.interestStudentCount, 0)
                        }}
                        </b>
                      </div>
                      <p class="fsize14">兴趣课程参与学员数</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bd flex1 mr16 merge" style="height: 112px">
                <div class="flex-items top-flex aic">
                  <div class="flex1 pdtm10">
                    <div class="icon mb9">
                      <img src="/index/icon5.png" />
                    </div>
                    <div class="text-line">
                      <div class="count fzize20">
                        <b>{{ currency(schoolTermOverPagePanelCoverage.trustStudentCount, 0)
                        }}</b>
                      </div>
                      <p class="fsize14">托管参与学员数</p>
                    </div>
                  </div>
                  <div class="flex1 pdtm10">
                    <div class="icon mb9">
                      <img src="/index/icon6.png" />
                    </div>
                    <div class="text-line">
                      <div class="count fzize20">
                        <b>{{ currency(schoolTermOverPagePanelCoverage.corStudentCount, 0)
                        }}</b>
                      </div>
                      <p class="fsize14">社团参与学员数</p>
                    </div>
                  </div>
                  <div class="flex1 pdtm10">
                    <div class="icon mb9">
                      <img src="/index/icon7.png" />
                    </div>
                    <div class="text-line">
                      <div class="count fzize20">
                        <b>{{ currency(schoolTermOverPagePanelCoverage.perStudentCount, 0)
                        }}</b>
                      </div>
                      <p class="fsize14">特色参与学员数</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-plate flex">
      <div class="bp-left flex1">
        <div class="flex mt16">
          <div class="plate-card flex1 mr16">
            <div class="plate-card-title mb24 flex-items">
              班级
              <a-popover arrow-point-at-center placement="bottomLeft">
                <template slot="title">
                  <p class="popover-title-b"><b>班级</b></p>
                </template>
                <template slot="content">
                  <ul class="popover-li">
                    <li>
                      <p><b>班级总数</b></p>
                      <p>指在本学期，所有预开班与已开班的班级总数。</p>
                    </li>
                    <li>
                      <p><b>参与总人次</b></p>
                      <p>指在本学期，进行报名的学员总人次。</p>
                    </li>
                    <li>
                      <p><b>报名班级总数</b></p>
                      <p>指在本学期，所有有学员报名的班级总数。</p>
                    </li>
                    <li>
                      <p><b>班级开班数</b></p>
                      <p>指在本学期，所有已开班的班级总数。</p>
                    </li>
                    <li>
                      <p><b>开班率</b></p>
                      <p>开班率 = 班级开班数 / 报名班级总数</p>
                    </li>
                    <li>
                      <p><b>托管 / 社团 / 特色报名班级总数</b></p>
                      <p>指在本学期，有学员报名的各类型班级总数。</p>
                    </li>
                    <li>
                      <p><b>托管 / 社团 / 特色开班数</b></p>
                      <p>指在本学期，已开班的各类型班级总数。</p>
                    </li>
                    <li>
                      <p><b>托管 / 社团 / 特色参与人次</b></p>
                      <p>指在本学期，各类型班级的报名人次。</p>
                    </li>
                  </ul>
                </template>
                <a-icon class="icon-circle" type="question-circle" />
              </a-popover>
            </div>
            <div class="mb24">
              <div class="flex mb16">
                <div class="flex1 pdtb bd mr16">
                  <div class="count fsize30 mb10">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.classCount, 0)
                    }}</b>
                  </div>
                  <div class="text">班级总数</div>
                </div>
                <div class="flex1 pdtb bd">
                  <div class="count fsize30 mb10">
                    <b>{{
                      currency(
                        schoolTermOverPagePanelClass.enrollPersonCount,
                        0
                      )
                    }}</b>
                  </div>
                  <div class="text">参与总人次</div>
                </div>
              </div>
              <div class="flex">
                <div class="flex1 pdtb bd mr16">
                  <div class="count fsize30 mb10">
                    <div class="flex-items">
                      <b>{{
                        currency(
                          schoolTermOverPagePanelClass.enrollClassCount,
                          0
                        )
                      }}</b>
                      <div class="bd-l"></div>
                      <div class="percentage flex-items">
                        <b class="fsize20">
                          {{
                            calculatePercentage(
                              schoolTermOverPagePanelClass.enrollClassCount,
                              schoolTermOverPagePanelClass.classCount
                            )
                          }}
                        </b>
                        <span class="fsize14">报名率</span>
                      </div>
                    </div>
                  </div>
                  <div class="text">报名班级总数</div>
                </div>
                <div class="flex1 pdtb bd">
                  <div class="count fsize30 mb10">
                    <div class="flex-items">
                      <b>{{
                        currency(
                          schoolTermOverPagePanelClass.startClassCount,
                          0
                        )
                      }}</b>
                      <div class="bd-l"></div>
                      <div class="percentage flex-items">
                        <b class="fsize20">
                          {{
                            calculatePercentage(
                              schoolTermOverPagePanelClass.startClassCount,
                              schoolTermOverPagePanelClass.enrollClassCount
                            )
                          }}
                        </b>
                        <span class="fsize14">开班率</span>
                      </div>
                    </div>
                  </div>
                  <div class="text">班级开班数</div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="flex1 pd2420 mr16 bd">
                <div class="icon mb24">
                  <img src="/index/icon5.png" />
                </div>
                <div class="text-line mb24">
                  <div class="count fzize20 mb10">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.trustEnrollCount, 0)
                    }}</b>
                  </div>
                  <p class="text">托管报名总班数</p>
                </div>
                <div class="text-line mb24">
                  <div class="count fzize20">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.trustStartCount, 0)
                    }}</b>
                  </div>
                  <p class="text">托管开班数</p>
                  <p class="percentage fzize14" style="padding-top: 10px">
                    <b>
                      {{
                        calculatePercentage(
                          schoolTermOverPagePanelClass.trustStartCount,
                          schoolTermOverPagePanelClass.trustEnrollCount
                        )
                      }}
                    </b>
                    <span>开班率</span>
                  </p>
                </div>
                <div class="text-line">
                  <div class="count fzize20">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.trustPersonCount, 0)
                    }}</b>
                  </div>
                  <p class="text">托管参与人次</p>
                </div>
              </div>
              <div class="flex1 pd2420 mr16 bd">
                <div class="icon mb24">
                  <img src="/index/icon6.png" />
                </div>
                <div class="text-line mb24">
                  <div class="count fzize20 mb10">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.corEnrollCount, 0)
                    }}</b>
                  </div>
                  <p class="text">社团报名总班数</p>
                </div>
                <div class="text-line mb24">
                  <div class="count fzize20">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.corStartCount, 0)
                    }}</b>
                  </div>
                  <p class="text">社团开班数</p>
                  <p class="percentage fzize14" style="padding-top: 10px">
                    <b>
                      {{
                        calculatePercentage(
                          schoolTermOverPagePanelClass.corStartCount,
                          schoolTermOverPagePanelClass.corEnrollCount
                        )
                      }}
                    </b>
                    <span>开班率</span>
                  </p>
                </div>
                <div class="text-line">
                  <div class="count fzize20">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.corPersonCount, 0)
                    }}</b>
                  </div>
                  <p class="text">社团参与人次</p>
                </div>
              </div>
              <div class="flex1 pd2420 bd">
                <div class="icon mb24">
                  <img src="/index/icon7.png" />
                </div>
                <div class="text-line mb24">
                  <div class="count fzize20 mb10">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.perEnrollCount, 0)
                    }}</b>
                  </div>
                  <p class="text">特色报名总班数</p>
                </div>
                <div class="text-line mb24">
                  <div class="count fzize20">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.perStartCount, 0)
                    }}</b>
                  </div>
                  <p class="text">特色开班数</p>
                  <p class="percentage fzize14" style="padding-top: 10px">
                    <b>
                      {{
                        calculatePercentage(
                          schoolTermOverPagePanelClass.perStartCount,
                          schoolTermOverPagePanelClass.perEnrollCount
                        )
                      }}
                    </b>
                    <span>开班率</span>
                  </p>
                </div>
                <div class="text-line">
                  <div class="count fzize20">
                    <b>{{
                      currency(schoolTermOverPagePanelClass.perPersonCount, 0)
                    }}</b>
                  </div>
                  <p class="text">特色参与人次</p>
                </div>
              </div>
            </div>
          </div>
          <div class="block-right flex1">
            <div class="plate-card mb16">
              <div class="plate-card-title mb24 flex-items">
                师资
                <a-popover arrow-point-at-center placement="bottomLeft">
                  <template slot="title">
                    <p class="popover-title-b"><b>师资</b></p>
                  </template>
                  <template slot="content">
                    <ul class="popover-li">
                      <li>
                        <p>
                          参与老师总数指在本学期，在预开班与已开班的班级上，设置为主讲老师和助教老师的总数（去重）。
                        </p>
                      </li>
                      <li>
                        <p>
                          校内参与老师总数指在本学期，在预开班与已开班的班级上，设置为主讲老师和助教老师的校内老师总数（去重）。
                        </p>
                      </li>
                      <li>
                        <p>
                          校外参与老师总数指在本学期，在预开班与已开班的班级上，设置为主讲老师和助教老师的校外老师总数（去重）。
                        </p>
                      </li>
                      <!-- <li>
                        <p>
                          备注：校外老师可在多个学校上课，因此所有学校的校外老师总数之和与本数字并不相等。
                        </p>
                      </li> -->
                    </ul>
                  </template>
                  <a-icon class="icon-circle" type="question-circle" />
                </a-popover>
              </div>
              <div class="flex mb16">
                <div class="icon mr20">
                  <img src="/index/icon8.png" />
                </div>
                <div class="right-text">
                  <div class="fsize30 mb10">
                    <b>{{
                      currency(
                        schoolTermOverPagePanelTeachers.parTeacherCount,
                        0
                      )
                    }}</b>
                  </div>
                  <p>参与老师总数</p>
                </div>
              </div>
              <div class="flex">
                <div class="flex1 bd pd24 mr16">
                  <div class="count fsize20 mb10">
                    <b>{{
                      currency(
                        schoolTermOverPagePanelTeachers.insideTeacherCount,
                        0
                      )
                    }}</b>
                  </div>
                  <p class="text">校内参与老师总数</p>
                </div>
                <div class="flex1 bd pd24">
                  <div class="count fsize20 mb10">
                    <b>{{
                      currency(
                        schoolTermOverPagePanelTeachers.outsideTeacherCount,
                        0
                      )
                    }}</b>
                  </div>
                  <p class="text">校外参与老师总数</p>
                </div>
              </div>
            </div>
            <div class="plate-card" style="padding-bottom: 62px">
              <div class="plate-card-title mb24 flex-items">
                收费
                <a-popover arrow-point-at-center placement="bottomLeft">
                  <template slot="title">
                    <p class="popover-title-b"><b>收费</b></p>
                  </template>
                  <template slot="content">
                    <ul class="popover-li">
                      <li>
                        <p>
                          净收总额指本学期，收费减去退费的总金额。备注：退款中、退款失败、退款取消的金额不会计算在内。
                        </p>
                      </li>
                      <li>
                        <p>收费总额指本学期，所有家长成功缴费的总金额。</p>
                      </li>
                      <li>
                        <p>
                          非零收款单指本学期，所有家长成功缴费的总订单数（订单金额大于0元）。
                        </p>
                      </li>
                      <li>
                        <p>单均金额单均金额 = 收费总额 / 非零收款单。</p>
                      </li>
                      <li>
                        <p><b>退费总额</b></p>
                        <p>指本学期，所有家长的已完成退费的实际退款金额总和（实际退款金额可能不等于订单付款金额）。</p>
                      </li>
                      <li>
                        <p><b>非零退费单</b></p>
                        <p>指本学期，所有订单状态为退课成功并且订单金额不为0的订单总数（退课成功的订单实际退款单可能还在退款中）。</p>
                      </li>
                      <li>
                        <p><b>退费率</b></p>
                        <p>退费率 = 非零退费单量/非零收费单。</p>
                      </li>
                    </ul>
                  </template>
                  <a-icon class="icon-circle" type="question-circle" />
                </a-popover>
              </div>
              <div class="flex mb20">
                <div class="icon mr20">
                  <img src="/index/icon9.png" />
                </div>
                <div class="right-text">
                  <div class="fsize30 orgin mb10">
                    <b class="hidden">￥{{
                      currency(schoolTermOverPagePanelToll.incomeTotal / 100)
                    }}</b>
                  </div>
                  <p class="hidden">净收总额</p>
                </div>
              </div>
              <div class="flex charge-box">
                <div class="flex1 bd pd24 mr16">
                  <div class="count green fsize20">
                    <b class="hidden">+ ￥{{
                      currency(schoolTermOverPagePanelToll.collectTotal / 100)
                    }}</b>
                  </div>
                  <p class="text">收费总额</p>
                  <p class="detail-text">
                    <span class="title">非零收费单</span>
                    <span class="content">{{
                      currency(
                        schoolTermOverPagePanelToll.notZeroCollectTotal,
                        0
                      )
                    }}</span>
                  </p>
                  <p class="detail-text">
                    <span class="title">单均金额</span>
                    <span class="content">￥{{
                      !schoolTermOverPagePanelToll.collectTotal
                        ? 0
                        : (
                          schoolTermOverPagePanelToll.collectTotal /
                          100 /
                          schoolTermOverPagePanelToll.notZeroCollectTotal
                        ).toFixed(2)
                    }}
                    </span>
                  </p>
                </div>
                <div class="flex1 bd pd24">
                  <div class="count red fsize20">
                    <b class="hidden">- ￥{{
                      currency(schoolTermOverPagePanelToll.refundTotal / 100)
                    }}</b>
                  </div>
                  <p class="text">退费总额</p>
                  <p class="detail-text">
                    <span class="title">非零退费单</span>
                    <span class="content">{{
                      currency(
                        schoolTermOverPagePanelToll.notZeroRefundTotal,
                        0
                      )
                    }}</span>
                  </p>
                  <p class="detail-text">
                    <span class="title">退费率</span>
                    <span class="content">
                      {{
                        calculatePercentage(
                          schoolTermOverPagePanelToll.notZeroRefundTotal,
                          schoolTermOverPagePanelToll.notZeroCollectTotal
                        )
                      }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bp-right" style="margin-top: 16px">
        <div class="chart">
          <div class="plate-card course chart-card">
            <div class="plate-card-title mb24 flex-items">
              课程占比
              <a-popover arrow-point-at-center placement="bottomLeft">
                <template slot="title">
                  <p class="popover-title-b"><b>课程占比</b></p>
                </template>
                <template slot="content">
                  <ul class="popover-li">
                    <li>
                      <p><b>各类课程数量</b></p>
                      <p>
                        指本学期，所有预开班与已开班班级（托管班除外）所对应课程的数量（去重）。
                      </p>
                    </li>
                  </ul>
                </template>
                <a-icon class="icon-circle" type="question-circle" />
              </a-popover>
            </div>
            <div class="flex">
              <div class="right-chart1"></div>
              <div class="left-table">
                <ul>
                  <li>
                    <span></span>
                    <span>课程数</span>
                    <span>占比</span>
                  </li>
                  <li>
                    <span>德育</span>
                    <span>{{ currency(courseShare.moralityCount, 0) }}</span>
                    <span>{{
                      calculatePercentage(
                        courseShare.moralityCount,
                        courseShareTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>智育</span>
                    <span>{{
                      currency(courseShare.intellectuallyCount, 0)
                    }}</span>
                    <span>{{
                      calculatePercentage(
                        courseShare.intellectuallyCount,
                        courseShareTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>体育</span>
                    <span>{{ currency(courseShare.physicallyCount, 0) }}</span>
                    <span>{{
                      calculatePercentage(
                        courseShare.physicallyCount,
                        courseShareTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>美育</span>
                    <span>{{ currency(courseShare.artCount, 0) }}</span>
                    <span>{{
                      calculatePercentage(
                        courseShare.artCount,
                        courseShareTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>劳育</span>
                    <span>{{ currency(courseShare.laborCount, 0) }}</span>
                    <span>{{
                      calculatePercentage(
                        courseShare.laborCount,
                        courseShareTotal
                      )
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="plate-card family mt16 chart-card" style="padding-bottom: 127px">
            <div class="plate-card-title mb24 flex-items">
              家长满意度
              <a-popover arrow-point-at-center placement="bottomLeft">
                <template slot="title">
                  <p class="popover-title-b"><b>家长满意度</b></p>
                </template>
                <template slot="content">
                  <ul class="popover-li">
                    <li>
                      <p><b>分数占比</b></p>
                      <p>
                        指本学期，家长对课程不同分值的评价，占所有评价数中的百分比。
                      </p>
                    </li>
                  </ul>
                </template>
                <a-icon class="icon-circle" type="question-circle" />
              </a-popover>
            </div>
            <div class="flex">
              <div class="right-chart2"></div>
              <div class="left-table">
                <ul>
                  <li>
                    <span></span>
                    <span></span>
                    <span>占比</span>
                  </li>
                  <li>
                    <span>5分</span>
                    <span></span>
                    <span>{{
                      calculatePercentage(
                        parentalSatisfaction.fiveSatisfaction,
                        parentalSatisfactionTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>4分</span>
                    <span></span>
                    <span>{{
                      calculatePercentage(
                        parentalSatisfaction.fourSatisfaction,
                        parentalSatisfactionTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>3分</span>
                    <span></span>
                    <span>{{
                      calculatePercentage(
                        parentalSatisfaction.threeSatisfaction,
                        parentalSatisfactionTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>2分</span>
                    <span></span>
                    <span>{{
                      calculatePercentage(
                        parentalSatisfaction.twoSatisfaction,
                        parentalSatisfactionTotal
                      )
                    }}</span>
                  </li>
                  <li>
                    <span>1分</span>
                    <span></span>
                    <span>{{
                      calculatePercentage(
                        parentalSatisfaction.oneSatisfaction,
                        parentalSatisfactionTotal
                      )
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { currency } from '../../utils'
import Vue from 'vue'

import synopsis from '../../api/synopsis.js'

export default {
  data() {
    return {
      currency,
      timeUpdateText: "",
      courseShareTotal: 0,
      /**
       * 课程占比
       */
      courseShare: {
        /**
         * 美育
         */
        artCount: 0,
        /**
         * 智育
         */
        intellectuallyCount: 0,
        /**
         * 劳育
         */
        laborCount: 0,
        /**
         * 德育
         */
        moralityCount: 0,
        /**
         * 体育
         */
        physicallyCount: 0,
      },
      parentalSatisfactionTotal: 0,
      /**
       * 家长满意度
       */
      parentalSatisfaction: {
        fiveSatisfaction: 0,
        fourSatisfaction: 0,
        threeSatisfaction: 0,
        twoSatisfaction: 0,
        oneSatisfaction: 0,
      },
      /**
       * 班级
       */
      schoolTermOverPagePanelClass: {
        classCount: 0,
        corEnrollCount: 0,
        corPersonCount: 0,
        corStartCount: 0,
        enrollClassCount: 0,
        enrollPersonCount: 0,
        perEnrollCount: 0,
        perPersonCount: 0,
        perStartCount: 0,
        startClassCount: 0,
        trustEnrollCount: 0,
        trustPersonCount: 0,
        trustStartCount: 0,
      },
      /**
       * 覆盖率
       */
      schoolTermOverPagePanelCoverage: {
        corStudentCount: 0,
        parSchoolCount: 0,
        parStudentCount: 0,
        perStudentCount: 0,
        regStudentCount: 0,
        schoolCount: 0,
        trustStudentCount: 0,
      },
      /**
       * 师资
       */
      schoolTermOverPagePanelTeachers: {
        insideTeacherCount: 0,
        outsideTeacherCount: 0,
        parTeacherCount: 0,
      },
      /**
       * 收费
       */
      schoolTermOverPagePanelToll: {
        collectTotal: 0,
        incomeTotal: 0,
        notZeroCollectTotal: 0,
        notZeroRefundTotal: 0,
        refundTotal: 0,
      },
      pieChart1: null,
      pieChart2: null,
      rankCode: null,
      termId: null,
      termList: [],
      rankingListType: [],
      rankingList: [],
      schoolId: Vue.ls.get('schoolId'),
    }
  },
  computed: {
    termName: (overviewTerm) => {
      if (!overviewTerm.termList.length) return ''
      return overviewTerm.termList.filter(
        (item) => item.id === overviewTerm.termId
      )[0].termName
    },
  },
  created() {
    // console.log('schoolId', Vue.ls.get('schoolId'))
  },
  mounted() {
    // console.log(
    //   'localStorage',
    //   JSON.parse(localStorage.getItem('schoolId')).value
    // )
    this.getTermList().then(() => {
      // 初始化
      this.init()
      // 获取排行类型
    })
  },
  methods: {
    getShowUpdateText(text) {
      if (text && text.length > 0) {
        let date = new Date(text);
        if (date && date.getFullYear() >= 2000) {
          return "以下数据更新于"
            + date.toLocaleDateString('zh-CN', { dateStyle: 'long' })
            + date.toLocaleTimeString('zh-CN', { timeStyle: 'short', hour12: false });
        }
      }

      return "";
    },
    // 获取学期列表
    async getTermList() {
      const data = await synopsis.getTermList({ schoolId: this.schoolId })
      console.log('data', data)
      if (!data) return
      this.termList = data.data
      this.termId = data.data[0].id
    },

    // 计算百分比
    calculatePercentage(num, total) {
      if (!num || !total) return '0%'
      return ((num / total) * 100).toFixed(2) + '%'
    },
    // 饼图初始化
    chartInit() {
      console.log('饼图')
      this.pieChart1 = echarts.init(document.querySelector('.right-chart1'))
      this.pieChart2 = echarts.init(document.querySelector('.right-chart2'))
      const {
        artCount,
        intellectuallyCount,
        laborCount,
        moralityCount,
        physicallyCount,
      } = this.courseShare
      const chart1Data = [
        {
          value: moralityCount,
          name: '德育',
        },
        {
          value: intellectuallyCount,
          name: '智育',
        },
        {
          value: physicallyCount,
          name: '体育',
        },
        {
          value: artCount,
          name: '美育',
        },
        {
          value: laborCount,
          name: '劳育',
        },
      ]
      const total1Data = currency(
        artCount +
        intellectuallyCount +
        laborCount +
        moralityCount +
        physicallyCount,
        0
      )
      const chart1Options = this.chartOptions(
        '课程占比',
        chart1Data,
        ['#FFDD00', '#6B81FE', '#35B962', '#FF576C', '#FF9137'],
        total1Data
      )
      this.pieChart1.setOption(chart1Options)

      const {
        fiveSatisfaction,
        fourSatisfaction,
        oneSatisfaction,
        threeSatisfaction,
        twoSatisfaction,
      } = this.parentalSatisfaction
      const chart2Data = [
        {
          value: fiveSatisfaction,
          name: '5分',
        },
        {
          value: fourSatisfaction,
          name: '4分',
        },
        {
          value: threeSatisfaction,
          name: '3分',
        },
        {
          value: twoSatisfaction,
          name: '2分',
        },
        {
          value: oneSatisfaction,
          name: '1分',
        },
      ]
      const total2Data = chart2Data.reduce(
        (a, b, index) => {
          return [b.value * (5 - index) + a[0], a[1] + b.value]
        },
        [0, 0]
      )
      const average = Number((total2Data[0] / total2Data[1]).toFixed(2))
      const chart2Options = this.chartOptions(
        '平均分',
        chart2Data,
        ['#44D536', '#EEE100', '#FF9E00', '#FF6237', '#EE0825'],
        isNaN(average) ? 0 : average
      )
      this.pieChart2.setOption(chart2Options)
    },
    chartOptions(name, data, color, total) {
      const options = {
        tooltip: {
          trigger: 'item',
        },
        color,
        // legend: {
        //   icon: "circle",
        //   bottom: "bottom",
        //   itemWidth: 8, // 设置宽度
        //   itemHeight: 8, // 设置高度
        // },
        title: {
          zlevel: 0,
          text: [`{value|${total}}`].join('\n'),
          top: '37%',
          left: '48%',
          textAlign: 'center',
          textStyle: {
            rich: {
              value: {
                color: '#35383E',
                fontSize: 20,
                lineHeight: 20,
              },
              name: {
                color: '#909399',
                fontSize: 6,
                lineHeight: 20,
              },
            },
          },
        },
        series: {
          name,
          type: 'pie',
          radius: ['30%', '60%'],
          top: -20,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 2,
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '40',
              fontWeight: 'bold',
            },
          },
          data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      }
      return options
    },
    async init() {
      const data = await synopsis.getTermSynopsis({
        termId: this.termId,
        schoolId: this.schoolId,
      })
      // console.log('data', data)
      if (!data) return
      const {
        courseShare,
        parentalSatisfaction,
        schoolTermOverPagePanelClass,
        schoolTermOverPagePanelCoverage,
        schoolTermOverPagePanelTeachers,
        schoolTermOverPagePanelToll,
      } = data.data
      if (data.data.updateTime) {
        this.timeUpdateText = this.getShowUpdateText(data.data.updateTime);
      }
      if (schoolTermOverPagePanelClass) {
        this.schoolTermOverPagePanelClass = schoolTermOverPagePanelClass
      } else {
        this.schoolTermOverPagePanelClass =
          defaultTermOverviewInfo.schoolTermOverPagePanelClass
      }
      if (schoolTermOverPagePanelCoverage) {
        this.schoolTermOverPagePanelCoverage = schoolTermOverPagePanelCoverage
      } else {
        this.schoolTermOverPagePanelCoverage =
          defaultTermOverviewInfo.schoolTermOverPagePanelCoverage
      }
      if (schoolTermOverPagePanelTeachers) {
        this.schoolTermOverPagePanelTeachers = schoolTermOverPagePanelTeachers
      } else {
        this.schoolTermOverPagePanelTeachers =
          defaultTermOverviewInfo.schoolTermOverPagePanelTeachers
      }
      if (schoolTermOverPagePanelToll) {
        this.schoolTermOverPagePanelToll = schoolTermOverPagePanelToll
      } else {
        this.schoolTermOverPagePanelToll =
          defaultTermOverviewInfo.schoolTermOverPagePanelToll
      }
      // 课程数
      if (courseShare) {
        this.courseShare = courseShare
        const {
          artCount,
          intellectuallyCount,
          laborCount,
          moralityCount,
          physicallyCount,
        } = courseShare
        // 总和
        this.courseShareTotal =
          artCount +
          intellectuallyCount +
          laborCount +
          moralityCount +
          physicallyCount
      } else {
        this.courseShare = defaultTermOverviewInfo.courseShare
        this.courseShareTotal = 0
      }
      // 家长满意度
      if (parentalSatisfaction) {
        this.parentalSatisfaction = parentalSatisfaction
        const {
          fiveSatisfaction,
          fourSatisfaction,
          oneSatisfaction,
          threeSatisfaction,
          twoSatisfaction,
        } = parentalSatisfaction
        // 总和
        this.parentalSatisfactionTotal =
          fiveSatisfaction +
          fourSatisfaction +
          oneSatisfaction +
          threeSatisfaction +
          twoSatisfaction
      } else {
        this.parentalSatisfaction = defaultTermOverviewInfo.parentalSatisfaction
        this.parentalSatisfactionTotal = 0
      }
      this.chartInit()
    },
    handleChange(termId) {
      this.termId = termId
      this.init()
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  padding: 24px;
  box-sizing: border-box;
  width: 100%;

  * {
    line-height: 1;
  }

  .top-desc {
    color: #aeb0ba;
    font-size: 14px;
    line-height: 1;
    margin-left: 8px;
  }

  .bottom-plate {
    margin-top: 0px;
  }
}

.plate-card {
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  border-radius: 4px;

  &-title {
    font-size: 20px;
    padding-left: 12px;
    position: relative;
    font-weight: 500;

    &::before {
      content: '';
      position: absolute;
      height: 20px;
      width: 8px;
      background-color: #178fff;
      left: 0;
      top: 50%;
      margin-top: -10px;
      border-radius: 2px;
    }
  }
}

.chart-card {
  padding: 21px 23px 16px 23px;
}

.bp-right {
  margin-left: 16px;
  width: 31%;
}

.ranking {
  margin-top: 24px;

  li {
    list-style: none;
    position: relative;
    margin-top: 16px;

    .number {
      width: 30px;
      height: 30px;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      color: #262626;
      border-radius: 100%;
      margin-right: 16px;
    }

    .first.number {
      color: #ad7e14 !important;
      background-color: #fff287;
    }

    .second.number {
      color: #6881a3 !important;
      background-color: #deecff;
    }

    .thirdly.number {
      color: #af876c !important;
      background-color: #efdfd4;
    }

    .school-name {
      color: #000;
      font-size: 16px;
    }

    .count {
      font-size: 14px;
      font-weight: 400;
      color: rgba(108, 110, 127, 0.85);
    }
  }
}

.mt16 {
  margin-top: 16px;
}

.mb16 {
  margin-bottom: 16px;
}

.mr6 {
  margin-right: 6px;
}

.mr16 {
  margin-right: 16px;
}

.ml16 {
  margin-left: 16px;
}

.mr20 {
  margin-right: 20px;
}

.mr14 {
  margin-right: 14px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb24 {
  margin-bottom: 24px;
}

.mt24 {
  margin-top: 24px;

}

.ml24 {
  margin-left: 24px;
}

.mr24 {
  margin-right: 24px;
}

.mb10 {
  margin-bottom: 10px;
}

.bd {
  border: 1px solid #f0f2f5;
  border-radius: 8px;
  box-sizing: border-box;
}

.pd20 {
  padding: 20px;
}

.pd24 {
  padding: 24px;
}

.pd2420 {
  padding: 24px 20px;
}

.pdtb {
  padding: 20px 24px;
}

.pdtb {
  padding: 19px 24px;
}

.pdtm10 {
  padding: 10px 10px;
}

.fsize30 {
  font-size: 30px;
}

h3.fsize30 {
  padding-top: 2px;
}

.fsize20 {
  font-size: 20px;
}

.fsize16 {
  font-size: 16px;
}

.fsize14 {
  font-size: 14px;
}

.green {
  color: #4cce00;
}

.orgin {
  color: #d5ad2b;
}

.red {
  color: #ff3b2f;
}

// 百分比
.bd-l {
  background-color: #f0f2f5;
  width: 2px;
  height: 24px;
  margin: 0 16px;
}

.bd-ll {
  background-color: #f0f2f5;
  width: 2px;
  height: 24px;
}

.percentage {
  white-space: nowrap;

  b {
    color: #4cce00;
  }

  span {
    margin-left: 5px;
    color: #aeb0ba;
    font-size: 14px;
  }
}

.dashed-bd {
  height: 110px;
  width: 0px;
  margin: 0 24px;
  border-right: 1px dashed #f0f2f5;
}

.dashed-bd+.flex-items {
  height: 110px;

  .flex1 {
    height: 100%;
  }
}

.text-line {
  .count {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .text {
    font-size: 14;
    color: #35383e;
  }
}

.icon-circle {
  color: #b4b5bf;
  font-size: 16px;
  margin-left: 8px;

  &:hover {
    color: #11d690;
    cursor: pointer;
  }
}

.charge-box {
  .flex1 {
    .text {
      margin-bottom: 27px !important;
      margin-top: 12px !important;
      color: #35383e;
    }

    p {
      font-size: 14px;
    }

    p.detail-text {
      margin-top: 12px !important;

      .title {
        display: inline-block;
        color: #6c6e7f;
        margin-right: 20px;
        width: 70px;
      }
    }
  }
}

.left-table {
  width: 200px;

  ul {
    margin-bottom: 0;
  }

  li {
    height: 32px;
    font-size: 14px;
    display: flex;
    align-items: center;

    span {
      flex: 1;

      &:first-child {
        text-align: center;
      }
    }

    &:nth-child(odd) {
      background-color: #f2f9fc;
    }

    &:first-child {
      background-color: transparent;
    }
  }
}

.right-chart1,
.right-chart2 {
  width: calc(100% - 200px);
  height: 192px;
}

h3.blue-bg {
  background-color: #eff8ff;
  padding: 8px 12px !important;

  .count {
    font-size: 14px;
  }
}

@media screen and (max-width: 1500px) {
  .bottom-plate {
    display: block;

    .bp-right {
      width: 100%;
      margin-left: 0;
      margin-top: 16px;

      .chart {
        width: 100%;
        display: flex;

        .plate-card {
          display: inline-block;
          flex: 1;
          margin-bottom: 16px;
        }

        .plate-card.mt16 {
          margin-left: 0;
          margin-top: 1px;
        }

        .family {
          padding-bottom: 16px !important;
        }

        .course {
          margin-right: 16px !important;
        }
      }

      .plate-card.mt16 {
        flex: 1;
        margin-top: 0;
        margin-left: 16px;
      }
    }
  }
}

.popover-li {
  position: relative;

  li {
    position: relative;
    padding-left: 14px;
    margin-bottom: 14px !important;

    &::before {
      content: '';
      position: absolute;
      width: 4px;
      height: 4px;
      background-color: #35383e;
      border-radius: 100%;
      left: 0;
      top: 8px;
    }
  }
}

.popover-title-b {
  padding: 10px 0px;
  font-size: 17px;
  font-weight: bold;
}

.go-detail {
  font-size: 14px;
}

.merge {
  h3 {
    padding: 10px 0 8px;
    margin-bottom: 0;
    border-bottom: 1px solid #f0f2f5;
  }
}

.top {
  margin-top: 40px;
}

.bd-l2 {
  background-color: #f0f2f5;
  width: 2px;
  height: 90px;
  margin: 0 14px;
}

.aic {
  height: 112px;
  align-items: center;
}

@media screen and (max-width: 1300px) {
  .puhui {
    width: 200px !important;
  }
}
</style>
